import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ups-list',
    template: require('./ups-list.component.html'),
    encapsulation: ViewEncapsulation.None
})
/** ups-list component*/
export class UpsListComponent {
    /** ups-list ctor */
    constructor() {

    }
}